







































import { Suggestion } from '~/components/shared/configurable/form/autocomplete/Suggestion'
import { v4 as uuidv4 } from 'uuid'
import {
  computed,
  ComputedRef,
  defineComponent,
  ref
} from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { computeFieldState } from '~/utils/form'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import { useDep } from '~/compositions/dependency-container'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  components: { FieldError },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = props
    const paymentValue = ref(null)
    const labelValue = ref(null)
    const labelDatalistId = uuidv4()
    const labelError = ref(null)
    const paymentError = ref(null)

    function onValue(v: Ref<any>) {
      if (!v.value) {
        paymentValue.value = null
        labelValue.value = null
        return
      }
      paymentValue.value = v.value.value
      labelValue.value = v.value.label
    }
    const { debouncedValueChanged } = useClassifiedForm(props, { onValue })
    const formValidationBuilder = useDep(FormValidationBuilder)

    const min = computed(() => specs?.min)
    const max = computed(() => specs?.max)
    const suffix = computed(() => specs?.prefix || specs?.suffix || '€')
    const paymentIsValid = computed(() => computeFieldState(paymentError.value))
    const labelIsValid = computed(() => computeFieldState(labelError.value))

    const labelSuggestions: ComputedRef<Suggestion[]> = computed(() =>
      (specs?.labels || []).map((label: string, index: number) => {
        return {
          id: `label-${index}`,
          displayText: label
        }
      })
    )

    function handleLabelChange(label: string) {
      formValidationBuilder
        .new(labelError)
        .required(specs?.required, label)
        .maxChars(specs?.label_max, label)
        .minChars(specs?.label_min, label)
        .validate()

      debouncedValueChanged(name, {
        label,
        value: paymentValue.value
      })
    }
    const handlePaymentChange = (payment: string) => {
      const paymentNumber = Number(payment)
      formValidationBuilder
        .new(paymentError)
        .required(specs?.required, paymentNumber)
        .aboveMinNumber(specs?.min, paymentNumber)
        .belowMaxNumber(specs?.max, paymentNumber)
        .validate()
      debouncedValueChanged(name, {
        label: labelValue.value,
        value: payment
      })
    }

    return {
      paymentValue,
      labelValue,
      labelDatalistId,
      labelError,
      paymentError,
      min,
      max,
      suffix,
      paymentIsValid,
      labelIsValid,
      labelSuggestions,
      handleLabelChange,
      handlePaymentChange
    }
  }
})
